const emptyHTMLString = "<p>&nbsp;</p>";

export const validateNormalReservationSettingsForm = (data) => {
  const errors = {};
  if (!data.collaborationId?.trim()) {
    errors.collaborationId = "Collaboration ID is required.";
  }
  if (
    !data.generalDescription?.trim() ||
    data.generalDescription === emptyHTMLString
  ) {
    errors.generalDescription = "General description is required.";
  }
  if (!data.normalSettings.maxPaxSelection) {
    errors.maxPaxSelection = "Max pax selection is required.";
  } else if (data.normalSettings.maxPaxSelection <= 0) {
    errors.maxPaxSelection = "Max pax selection must at least 1.";
  }
  if (
    !data.normalSettings.reservationDescription?.trim() ||
    data.normalSettings.reservationDescription === emptyHTMLString
  ) {
    errors.reservationDescription = "Reservation description is required.";
  }
  return errors;
};

export const validateNormalReservationTimeSlotSettingsForm = (data) => {
  const errors = {};
  if (!data.slotTitle?.trim()) {
    errors.slotTitle = "Slot title is required.";
  }
  if (!data.slotStatus?.trim()) {
    errors.slotStatus = "Slot status is required.";
  }
  if (!data.maxPax) {
    errors.maxPax = "Max pax is required.";
  } else if (data.maxPax <= 0) {
    errors.maxPax = "Max pax must at least 1.";
  }
  if (!data.startTime?.trim()) {
    errors.startTime = "Start time is required.";
  }
  if (!data.endTime?.trim()) {
    errors.endTime = "End time is required.";
  }
  return errors;
};
